module.exports = __webpack_public_path__ + "static/img/solutionLeft.7d6f50d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionLeft.png
// module id = DTmz
// module chunks = 1